var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0313 33.9514H17.3751C16.1802 33.9514 15.2188 32.9901 15.2188 31.7952C15.2188 30.6003 16.1802 29.6389 17.3751 29.6389H25.8294L13.6915 17.51C12.847 16.6655 12.847 15.2999 13.6915 14.4643C14.536 13.6288 15.9017 13.6198 16.7372 14.4643L28.8661 26.5932V17.4202C28.8661 16.2253 29.8274 15.2639 31.0224 15.2639C32.2173 15.2639 33.1786 16.2253 33.1786 17.4202V31.7952C33.1786 32.9901 32.2173 33.9514 31.0224 33.9514H31.0313Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M23.125 0.888916C17.025 0.888916 11.1749 3.31212 6.86154 7.62546C2.54821 11.9388 0.125 17.7889 0.125 23.8889C0.125 29.9889 2.54821 35.839 6.86154 40.1524C11.1749 44.4657 17.025 46.8889 23.125 46.8889C29.225 46.8889 35.0751 44.4657 39.3885 40.1524C43.7018 35.839 46.125 29.9889 46.125 23.8889C46.125 17.7889 43.7018 11.9388 39.3885 7.62546C35.0751 3.31212 29.225 0.888916 23.125 0.888916ZM17.375 33.9514C16.1801 33.9514 15.2188 32.9901 15.2188 31.7952C15.2188 30.6002 16.1801 29.6389 17.375 29.6389H25.8293L13.6914 17.51C12.8469 16.6655 12.8469 15.2999 13.6914 14.4643C14.5359 13.6288 15.9016 13.6198 16.7371 14.4643L28.866 26.5932V17.4202C28.866 16.2252 29.8273 15.2639 31.0223 15.2639C32.2172 15.2639 33.1785 16.2252 33.1785 17.4202V31.7952C33.1785 32.9901 32.2172 33.9514 31.0223 33.9514H17.375Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/TrendDown.c8f52e675bb75085c77e5b97075ed332.svg";
export { ForwardRef as ReactComponent };